<template>
    <div>
        <div v-if="!_.isEmpty(step._fields)">
            <div v-for="(field,name) in step._fields" :key="name" class="field-container">
                <component :is="field._component" :key="name" :name="name" :field="field" :step="step"></component>
            </div>
        </div>
        <b-button type="is-primary" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>
    </div>
</template>

<script>
import mixin from "./travel_step_mixin";

export default {
    mixins: [mixin],
}
</script>

<style scoped>

</style>
